// extracted by mini-css-extract-plugin
module.exports = {"postTitle":"PageTemplate-module--postTitle--m3u2I","postExcerpt":"PageTemplate-module--postExcerpt--1M463"};